export const facebookAppId = "3375293559265744";
export const googleClientId =
  "984792856479-vbl9011ikj3ais9375j98f9mlik84v68.apps.googleusercontent.com";
export const facebookRedirectURI = "https://laughing-bose-a55b10.netlify.app";
export const apiURL = "https://abhi102.pythonanywhere.com/api/";
// export const apiURL = "http://localhost:8000/api/";
